import axios from "axios";
import { warn } from "@/game/log";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "tb_token";

export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const clearToken = () => sessionStorage.removeItem(TOKEN_KEY);

const http = axios.create({ baseURL: `${BACKEND_URL}/api` });
http.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
http.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/login")) {
      clearToken();
      window.dispatchEvent(new Event("tb-logout"));
    }
    return Promise.reject(err);
  }
);

export const formatError = (err, fallback) => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Please check what you typed and try again.";
  return fallback;
};

export const login = async (username, password) => {
  const { data } = await http.post("/auth/login", { username, password });
  sessionStorage.setItem(TOKEN_KEY, data.token);
  return data.player;
};

export const me = async () => {
  if (!getToken()) return null;
  try {
    const { data } = await http.get("/auth/me");
    return data;
  } catch {
    return null;
  }
};

export const logout = async () => {
  try {
    if (getToken()) await http.post("/auth/logout");
  } catch (err) {
    warn("Logout call failed:", err?.message);
  }
  clearToken();
};

export const completeLevel = async (name, payload) => {
  const { data } = await http.post(`/players/${encodeURIComponent(name)}/complete`, payload);
  return data;
};

export const getLeaderboard = async () => {
  const { data } = await http.get("/leaderboard");
  return data;
};
